const testimonial = [
	{
		name: "Shweta Tiwari",
    avatar: "./testimonial/shweta.jpg",
    profession:"Maths Teacher",
		message:
			"I have been a maths teacher since the last 12 years. Teaching has always remained orthodox however with the Scoar platform, I have been able to equip myself with technology easily and I recommend other teachers to do the same with their students as the future is online. Teachers get more time for themselves as well.",
	},
	{
		name: "Raj Sharma",
    avatar: "./testimonial/raj.png",
    profession:"Guitar Teacher",
		message:
			"I have been teaching Guitar since the last 4 years. Since the pandemic, I witnessed a fall in my students but after using the Scoar platform, I have been able to teach more students.",
	},
	{
		name: "Nidhi Singh",
    avatar: "./testimonial/nidhi.png",
    profession:"Fitness Coach",
		message:
			"Fitness has always been my passion. I try to keep myself fit every day and recommend the same to my students. The teaching platform Scoar has is well equipped to give fitness lessons and tips to students and everything can be done from the comfort of my home.",
	},
	{
		name: "Amit Gupta",
    avatar: "./testimonial/amit.png",
    profession:"Physics Teacher",
		message:
			" I am a Physics teacher for the last 5 years. Covid has given all the teachers the opportunity to become tech savvy and go online with their tuitions. Scoar platform and team are really helpful and I am a firm believer in their mission.",
	},
];

export default testimonial;
